"use strict";

exports.__esModule = true;
exports["default"] = exports.Promise = void 0;

var _utilsPolyfills = require("./utils.polyfills.js");

var ogPromise = global.Promise;

function $Promise(fn) {
  var res,
      rej,
      promise = new ogPromise(function (resolve, reject) {
    res = resolve;
    rej = reject;
    fn && fn(resolve, reject);
  });

  promise.resolve = function () {
    res.apply(promise, [].slice.call(arguments));
  };

  promise.reject = function () {
    rej.apply(promise, [].slice.call(arguments));
  };

  return promise;
}

['all', 'resolve', 'reject'].forEach(function (key) {
  $Promise[key] = ogPromise[key];
});
var Promise = $Promise;
exports.Promise = Promise;
var _default = $Promise;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/ereader-core/dist/utils.Promise.js
// module id = 507
// module chunks = 0